module.exports = __webpack_public_path__ + "img/500-fg.6fbdd64.png";